// Bridge the gap between SCSS and styled component without impacting the visual
export var HEADER_HEIGHT = 70;
// reusing some variables from src/stylesheets/base/config/_dimensions.sass
// export const SPACE = 16 // use Spacing.Small
export var WIDE_SPACE = 28;
export var WIDER_SPACE = 40;
export var DOUBLE_WIDE_SPACE = 64;
// reusing some variables packages/app-corp-consumer-portal/src/stylesheets/base/config/_colors.sass
// export const BRAND_RED = '#eb1700' // use Colors.SystemRed60
// export const FADED_RED = '#ffe0db' // use Colors.ButtonSecondaryBackgroundHovered
export var GRAY_100 = '#fafafa';
